// 提交表单
import { ref } from 'vue'
import { Toast, Notify } from 'vant'
export const loading = ref(false)
export const useSubmit = (
  method,
  params,
  callback,
  tip = '操作成功',
  callback2 = () => {}
) => {
  const onSubmit = async () => {
    loading.value = true
    // Toast.allowMultiple()
    const toast1 = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      overlay: true,
      message: '请稍后...'
    })
    try {
      const { status, message, data } = await method(params)
      if (status === 200) {
        toast1.clear()
        callback(data)
        Notify({ type: 'success', message: tip })
      } else {
        toast1.clear()
        Notify({ type: 'danger', message: message })
        callback2()
      }
      loading.value = false
    } catch {
      loading.value = false
      toast1.clear()
      callback2()
    }
  }
  return {
    loading,
    onSubmit
  }
}
